
import React, { useState, useEffect } from 'react';
import { ethers } from 'ethers';
import './Burn.css';

// Asumiendo que el ABI está en la misma ubicación relativa que en otros componentes
import WrappedTestnetBitcoin3 from './contracts/WrappedTestnetBitcoin3.json';
const wbtc3Abi = WrappedTestnetBitcoin3.abi;
const WTBTC3_CONTRACT_ADDRESS = '0x2137d2B151321659181D2519Ef2F5B5CAdD42664'; // Reemplaza con tu dirección de contrato

const Burn = () => {
    const [provider, setProvider] = useState(null);
    const [signer, setSigner] = useState(null);
    const [contract, setContract] = useState(null);
    const [userAddress, setUserAddress] = useState('');
    const [amount, setAmount] = useState('');
    const [btcAddress, setBtcAddress] = useState('');
    const [wbtcBalance, setWbtcBalance] = useState('0'); // New state for WBTC balance
    const [error, setError] = useState('');
    const [status, setStatus] = useState('');
    const [connecting, setConnecting] = useState(false);
    const [burning, setBurning] = useState(false);

    // Function to fetch WBTC balance
    const fetchBalance = async (contractInstance, address) => {
        if (contractInstance && address) {
            try {
                const balance = await contractInstance.balanceOf(address);
                setWbtcBalance(ethers.formatUnits(balance, 8)); // Assuming 8 decimals for WTBC3
            } catch (err) {
                console.error("Failed to fetch WBTC balance:", err);
                setError("Failed to fetch WBTC balance.");
            }
        }
    };

    useEffect(() => {
        if (window.ethereum) {
            const newProvider = new ethers.BrowserProvider(window.ethereum);
            setProvider(newProvider);
        } else {
            setError('MetaMask not found. Please install it to use this feature.');
        }
    }, []);

    useEffect(() => {
        if (contract && userAddress) {
            fetchBalance(contract, userAddress);
        }
    }, [contract, userAddress]); // Re-fetch balance when contract or userAddress changes

    const connectWallet = async () => {
        if (!provider) {
            setError('Ethereum provider is not available.');
            return;
        }
        setConnecting(true);
        setError('');
        setStatus('');
        try {
            const accounts = await window.ethereum.request({ method: 'eth_requestAccounts' });
            if (accounts.length > 0) {
                const currentSigner = await provider.getSigner();
                const currentAddress = await currentSigner.getAddress();
                setUserAddress(currentAddress);

                const wbtc3Contract = new ethers.Contract(WTBTC3_CONTRACT_ADDRESS, wbtc3Abi, currentSigner);
                setSigner(currentSigner);
                setContract(wbtc3Contract);
                // Fetch balance immediately after connecting
                fetchBalance(wbtc3Contract, currentAddress);
            } else {
                setError('No accounts found. Please unlock your MetaMask.');
            }
        } catch (err) {
            setError(err.message || 'Failed to connect wallet.');
        } finally {
            setConnecting(false);
        }
    };

    const handleBurn = async () => {
        if (!contract || !signer) {
            setError('Please connect your wallet first.');
            return;
        }
        if (!amount || isNaN(Number(amount)) || Number(amount) <= 0) {
            setError('Please enter a valid amount to burn.');
            return;
        }
        // Basic validation for BTC address (length and starts with 'm' or 'n' for testnet)
        if (!btcAddress || !/^[mn][a-km-zA-HJ-NP-Z1-9]{25,34}$/.test(btcAddress)) {
            setError('Please enter a valid Adrress');
            return;
        }

        setBurning(true);
        setError('');
        setStatus('Preparing burn proposal...');

        try {
            const amountInSatoshis = ethers.parseUnits(amount, 8); // WTBC3 has 8 decimals
            
            setStatus('Please confirm the transaction in your wallet...');
            
            const tx = await contract.requestBurn(amountInSatoshis, btcAddress);
            
            setStatus(`Transaction sent! Waiting for confirmation... TxHash: ${tx.hash}`);
            
            await tx.wait();
            
            setStatus(`Burn proposal successful! An oracle will confirm it soon. TxHash: ${tx.hash}`);
            setAmount('');
            setBtcAddress('');
            fetchBalance(contract, userAddress); // Refresh balance after successful burn

        } catch (err) {
            console.error(err);
            const errorMessage = err.reason || err.message || 'An unknown error occurred.';
            setError(`Failed to propose burn: ${errorMessage}`);
            setStatus('');
        } finally {
            setBurning(false);
        }
    };

    return (
        <div className="burn-container">
            <h2>BRIDGE WTBTC3 TO TBTC3</h2>
            
            {!userAddress ? (
                <button onClick={connectWallet} disabled={connecting} className="connect-wallet-btn">
                    {connecting ? 'Connecting...' : 'Connect MetaMask Wallet'}
                </button>
            ) : (
                <>
                    <p className="wallet-address">Connected: <strong>{userAddress}</strong></p>
                    <p className="wbtc-balance">Your WTBTC3 Balance: <strong>{wbtcBalance}</strong></p>
                </>
            )}

            {userAddress && (
                <div className="burn-form">
                    <div className="form-group">
                        <label>BRIDGE SEPOLIA WTBTC3 TO TBTC3:</label>
                        <input
                            type="text"
                            value={amount}
                            onChange={(e) => setAmount(e.target.value)}
                            placeholder="e.g., 0.005"
                            className="form-control"
                            disabled={burning}
                        />
                    </div>
                    <div className="form-group">
                        <label>Destination Bitcoin TESTNET 3 Address (TBTC3):</label>
                        <input
                            type="text"
                            value={btcAddress}
                            onChange={(e) => setBtcAddress(e.target.value)}
                            placeholder="e.g., m..."
                            className="form-control"
                            disabled={burning}
                        />
                    </div>
                    <button onClick={handleBurn} disabled={burning || !contract} className="submit-btn">
                        {burning ? 'Processing...' : 'BRIDGE'}
                    </button>
                </div>
            )}

            {error && <p className="error-message">{error}</p>}
            {status && <p className="status-message">{status}</p>}
        </div>
    );
};

export default Burn;
